import DialogActions from "@mui/material/DialogActions";

export default function AppDialogActions({ children, ...rest }) {
  return <DialogActions {...rest}>{children}</DialogActions>;
}
